import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  status: false,
  order: false,
  bags: false,
  pickup_address: false,
  dropoff_address: false,
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.STATUS_SET:
      return state.merge({
        status: action.value
      });
    case types.ORDER_SET:
      return state.merge({
        order: action.order,
        bags: action.bags,
        pickup_address: action.pickup_address,
        dropoff_address: action.dropoff_address
      });
    default:
      return state;
  }
}

// selectors
export function getStatus(state) {
  return state.status.status;
}

export function getOrder(state) {
  return state.status.order;
}

export function getBags(state) {
  return state.status.bags;
}

export function getPickupAddress(state) {
  return state.status.pickup_address;
}

export function getDropoffAddress(state) {
  return state.status.dropoff_address;
}
